import { FlexRow } from '@/components/common/Flex';
import { InfoCircle } from '@/components/common/icons';
import { Paragraph } from '@/components/common/Typography';
import { FlexProps } from '@chakra-ui/react';
import { FC } from 'react';

const Notice: FC<FlexProps> = ({ children, ...props }) => (
    <FlexRow {...props}>
        <InfoCircle size="md" mr={2} color="gray.400" />
        <Paragraph fontSize="sm" color="textMuted">
            {children}
        </Paragraph>
    </FlexRow>
);

export default Notice;
